import './styles/main.css';
import './demo';
console.log('Project started...');
const warn = document.querySelector('.js-warning');
warn.style.display = 'none';
